import './bootstrap';

$(document).ready(function(){
    var mutArray = []; //todo make dynamic, count with class "click-to-input" "mut"
    var mutPassword = ["934", "4" , "75", "10"];

    var hcpArray = []; //todo make dynamic, count with class "click-to-input" "hcp"
    var hcpPassword = ["934", "4" , "75", "10"];

    var passwordLength = mutPassword.length; //todo maybe mut and hcp password have different length

    $(".click-to-input").click(function(event){
        //console.log("clicked: " + event.target.id + " with value: " + document.getElementById(event.target.id).getAttribute('number'));
        event.preventDefault();

        if(document.getElementById(event.target.id).classList.contains('mut')){
            if(mutArray.length < passwordLength){
                mutArray.push(document.getElementById(event.target.id).getAttribute('number'));
                //console.log("mut array: " + mutArray);
                updateInputFields('mut');
            }
        }
        else{
            if(hcpArray.length < passwordLength){
                hcpArray.push(document.getElementById(event.target.id).getAttribute('number'));
                //console.log("hcp array: " + hcpArray);
                updateInputFields('hcp');
            }
        }

    });

    $(".delete-number-input").click(function(event){
        event.preventDefault();

        if(document.getElementById(event.target.id).classList.contains('mut')){
            mutArray.pop();
            //console.log("mut array: " + mutArray);
            updateInputFields('mut');
        }
        else{
            hcpArray.pop();
            //console.log("hcp array: " + hcpArray);
            updateInputFields('hcp');
        }
    });

    $(".confirm-button").click(function(event){
        //console.log("clicked: " + event.target.id);
        event.preventDefault();

        if(document.getElementById(event.target.id).classList.contains('mut')){
            handleConfirmButtonClicked('mut');
        }
        else{
            handleConfirmButtonClicked('hcp');
        }
    });

    $('#deepLinkModalMut').on('hidden.bs.modal', function (e) {
        resetInputFields();
    })
    $('#deepLinkModalHcp').on('hidden.bs.modal', function (e) {
        resetInputFields();
    })

    function updateInputFields(input) {
        if(input === 'mut'){
            //reset number inputs
            var numberInputs = document.querySelectorAll(".input-field.mut");
            for (var i = 0; i < numberInputs.length; i++) {
                document.getElementById(numberInputs.item(i).id).innerText = "";
            }

            //update number inputs
            var numberInputs = document.querySelectorAll(".input-field.mut");
            var arrayIndex = 0;
            for (var i = 0; i < numberInputs.length; i++) {
                //console.log("input field: " + numberInputs.item(i).id);
                //console.log("inner text: " + document.getElementById(numberInputs.item(i).id).innerText + " array: " + mutArray[arrayIndex]);

                if(document.getElementById(numberInputs.item(i).id).innerText === "" && typeof mutArray[arrayIndex] !== 'undefined'){
                    document.getElementById(numberInputs.item(i).id).innerText = mutArray[arrayIndex];
                    arrayIndex++;
                }
            }
        }
        else{
            //reset number inputs
            var numberInputs = document.querySelectorAll(".input-field.hcp");
            for (var i = 0; i < numberInputs.length; i++) {
                document.getElementById(numberInputs.item(i).id).innerText = "";
            }

            //update number inputs
            var numberInputs = document.querySelectorAll(".input-field.hcp");
            var arrayIndex = 0;
            for (var i = 0; i < numberInputs.length; i++) {
                //console.log("input field: " + numberInputs.item(i).id);
                //console.log("inner text: " + document.getElementById(numberInputs.item(i).id).innerText + " array: " + hcpArray[arrayIndex]);

                if(document.getElementById(numberInputs.item(i).id).innerText === "" && typeof hcpArray[arrayIndex] !== 'undefined'){
                    document.getElementById(numberInputs.item(i).id).innerText = hcpArray[arrayIndex];
                    arrayIndex++;
                }
            }
        }
    }

    function resetInputFields(){
        //reset number inputs
        var numberInputs = document.querySelectorAll(".input-field");
        for (var i = 0; i < numberInputs.length; i++) {
            document.getElementById(numberInputs.item(i).id).innerText = "";
        }

        mutArray=[];
        hcpArray=[];
    }

    function handleConfirmButtonClicked(confirmButton){
        if(confirmButton === 'mut'){
            if(JSON.stringify(mutPassword) === JSON.stringify(mutArray)){
                window.open(document.getElementById('confirm-button-mut').href, '_blank');
            }
        }
        else{
            if(JSON.stringify(hcpPassword) === JSON.stringify(hcpArray)){
                window.open(document.getElementById('confirm-button-hcp').href, '_blank');
            }
        }
    }
});
